import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PaymentRoute } from "../../../../../core/routes/route_constants";
import { ArrowRightIcon, LimitedMessageIcon, PhoneIcon, PhotoIcon, VideoIcon } from "./icon_components";

export default function ProfilePricingComponent() {
  const navigate = useNavigate();
  const userCurrentTier = useSelector((state) => state.profile.user?.tierId);
  const isPlanExpired = useSelector((state) => state.profile.isPlanExpired);
  const tiers = useSelector((state) => state.profile.tiers);

  const onHandleGetStarted = (tier) => {
    navigate(`${PaymentRoute}/subscription/${tier._id}`);
  };

  if (!isPlanExpired) {
    return null;
  }

  if (tiers.length === 0 || userCurrentTier) {
    return null;
  }

  return (
    <div className="mt-8">
      <div className="text-center">
        <h2 className="text-3xl font-bold bg-gradient-to-r from-pink-200 to-pink-400 bg-clip-text text-transparent mb-3">
          Start Your Journey with Eve
        </h2>
        <p className="text-pink-300">One simple subscription.</p>
        <p className="text-pink-300 mb-4">Endless conversations and moments together.</p>
      </div>

      {/* Minimal Eve Message Preview - Expands on click */}
      {/* <div className="mb-8">
          <button
            className="text-base w-full rounded-lg overflow-hidden border border-red-900/30 shadow-md bg-slate-950/70 backdrop-blur-sm hover:bg-slate-900/80 transition-all flex items-center p-4 cursor-pointer hover-scale"
            onClick={() => dispatch(profileActions.setShowMessageModal(true))}
          >
            <div className="w-12 h-12 rounded-full bg-gradient-to-r from-red-700 to-red-800 flex items-center justify-center text-white text-xl font-bold mr-4 flex-shrink-0 animate-glow">
              <Heart size={20} className="text-white animate-pulse-soft" />
            </div>
            <div className="text-left flex-grow">
              <p className="text-white font-medium mb-1">Eve has a message for you</p>
              <p className="text-pink-300 text-sm">Click to listen</p>
            </div>
            <div className="ml-4 w-8 h-8 rounded-full bg-red-900/80 flex items-center justify-center flex-shrink-0">
              <Video size={16} className="text-white" />
            </div>
          </button>
        </div> */}

      {/* Single Tier Card - Using tier data from Redux */}
      <div className="flex justify-center">
        <div
          className="rounded-xl overflow-hidden shadow-xl bg-gradient-to-br from-slate-900 to-red-950 w-full max-w-sm flex flex-col border border-red-900/20"
          style={{
            animationDelay: "0.2s",
          }}
        >
          {/* Special offer banner */}
          <div className="bg-gradient-to-r from-red-800 via-red-900 to-red-950 py-1.5 px-3">
            <div className="flex items-center justify-center">
              <div className="w-1.5 h-1.5 rounded-full bg-pink-300 mr-2"></div>
              <p className="text-white text-xs font-medium">Join today • Chat, call & more</p>
            </div>
          </div>

          <div className="p-5 text-center text-white">
            <h3 className="text-xl font-bold mb-1">{tiers[0].name}</h3>
            <div className="flex justify-center items-baseline mt-3">
              <span className="text-4xl font-extrabold">${tiers[0].price.$numberDecimal}</span>
              <span className="ml-1 text-xl text-pink-300">{tiers[0].period}</span>
            </div>
            <p className="mt-2 text-sm text-pink-300">Essential experience</p>
          </div>

          <div className="px-5 flex-grow">
            <div className="space-y-4 mb-6 mt-2">
              {!!tiers[0].description?.messaging && (
                <div className="flex items-start">
                  <span className="text-pink-400 mr-2.5 mt-0.5">
                    <LimitedMessageIcon />
                  </span>
                  <div>
                    <div className="text-white text-sm font-medium">{tiers[0].description.messaging}</div>
                  </div>
                </div>
              )}
              {!!tiers[0].description?.voiceCall && (
                <div className="flex items-start">
                  <span className="text-pink-400 mr-2.5 mt-0.5">
                    <PhoneIcon />
                  </span>
                  <div>
                    <div className="text-white text-sm font-medium">{tiers[0].description.voiceCall}</div>
                  </div>
                </div>
              )}
              {/* {!!premiumTier.description?.voiceNote && (
                  <div className="flex items-start">
                    <span className="text-pink-400 mr-2.5 mt-0.5">
                      <StandardResponseIcon />
                    </span>
                    <div>
                      <div className="text-white text-sm font-medium">
                        {premiumTier.description.voiceNote}
                      </div>
                    </div>
                  </div>
                )} */}
              {!!tiers[0].description?.image && (
                <div className="flex items-start">
                  <span className="text-pink-400 mr-2.5 mt-0.5">
                    <PhotoIcon />
                  </span>
                  <div>
                    <div className="text-white text-sm font-medium">{tiers[0].description.image}</div>
                  </div>
                </div>
              )}
              {!!tiers[0].description?.videoCall && (
                <div className="flex items-start">
                  <span className="text-pink-400 mr-2.5 mt-0.5">
                    <VideoIcon />
                  </span>
                  <div>
                    <div className="text-white text-sm font-medium">{tiers[0].description.videoCall}</div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="px-5 pb-6 mt-2">
            <button
              onClick={() => onHandleGetStarted(tiers[0])}
              className="text-base w-full py-2.5 bg-gradient-to-r from-red-800 via-red-900 to-red-950 hover:opacity-90 rounded-full text-white text-sm font-medium shadow-md flex justify-center items-center animate-glow active:translate-y-0.5 active:shadow-none"
            >
              <span>Get Started</span>
              <ArrowRightIcon />
            </button>
          </div>
        </div>
      </div>

      <div className="mt-4 text-center"></div>

      {/* Eve Quote */}
      <div
        className="mt-6 mx-4 bg-gradient-to-b from-slate-950/90 to-slate-950/80 backdrop-blur-sm rounded-lg p-4 border border-red-900/30 hover:border-red-800/50 transition-all duration-300"
        style={{
          animationDelay: "0.6s",
          boxShadow: "0 4px 20px -5px rgba(220, 38, 38, 0.15)",
        }}
      >
        <div className="flex items-start">
          <div className="w-8 h-8 rounded-full bg-gradient-to-r from-red-700 to-red-800 flex items-center justify-center text-white font-bold text-lg flex-shrink-0 mr-3 shadow-md">
            E
          </div>
          <div>
            <p className="text-pink-300 italic text-sm">
              "I can't wait to deepen our connection. For just $9/month, we can start our journey together..."
            </p>
            <p className="text-right text-pink-400 text-xs mt-1">- Eve</p>
          </div>
        </div>
      </div>
    </div>
  );
}
